<template>
  <div>
    <b-row>
      <b-col lg="6">
        <ValidationProvider
          ref="provider"
          :rules="{ required: dueDateRequired }"
          name="Fecha de compromiso"
          v-slot="{ errors, valid}"
        >
          <b-form-group>
            <template #label>
              <span>Fecha de compromiso</span><span v-show="dueDateRequired" class="asterisk">*</span>
            </template>
            <b-input
              type="date"
              id="due_on"
              v-model="serviceForm.due_on"
              :min="minDate"
              :state="(errors[0] || !valid) ? false : true"
              placeholder="Elegir fecha.."
              class="form-control white-flatpickr-input w-100"
            />
          </b-form-group>
        </ValidationProvider>

        <ValidationProvider :rules="{ required: true }" name="categoría" v-slot="{ errors }">
          <b-form-group>
            <template #label>
              <span>Categoría del servicio</span><span class="asterisk">*</span>
            </template>
            <b-select
              v-model="serviceForm.sap_series"
              :options="sapSeriesOptions"
              :state="errors[0] ? false : null"
            >
              <template #first>
                <option :value="null" disabled>-- Seleccionar --</option>
              </template>
            </b-select>
          </b-form-group>
        </ValidationProvider>

        <ValidationProvider :rules="{required: true}" name="unidad de negocio" v-slot="{ valid, errors }">
          <b-form-group>
            <template #label><span>Unidad de negocio</span></template>
            <b-select
              v-model="serviceForm.call_type"
              :options="businessUnitOptions"
              :state="(errors[0] || !valid)  ? false : true"
            >
              <template #first>
                <option :value="null">-- Seleccionar --</option>
              </template>
            </b-select>
          </b-form-group>
        </ValidationProvider>

        <ValidationProvider :rules="{max: 36}" name="serie" v-slot="{ valid, errors }">
          <b-form-group label="Número de serie">
            <b-input
              v-model="serviceForm.item_serial_no"
              type="text"
              placeholder="Número de serie del equipo"
              :state="(errors[0] || !valid)  ? false : true"
            />
          </b-form-group>
        </ValidationProvider>

        <ValidationProvider :rules="{ required: true, max: 250 }" name="problema" v-slot="{ valid, errors }">
          <b-form-group>
            <template #label>
              <span>Descripción del problema</span><span class="asterisk">*</span>
            </template>
            <b-textarea
              v-model="serviceForm.subject"
              placeholder="Descripción del problema"
              rows="4"
              :state="(errors[0] || !valid) ? false : null"
            />
          </b-form-group>
        </ValidationProvider>
      </b-col>
      <b-col lg="6">
        <b-row>
          <b-col cols="6">
            <b-form-group>
              <template #label>
                <span>¿Es un problema recurrente?</span><span class="asterisk">*</span>
              </template>
              <div class="d-flex">
                <b-button
                  class="mr-2"
                  :variant="serviceForm.is_recurring == null ? 'outline-danger' : serviceForm.is_recurring === true ? 'primary' : 'outline-secondary'"
                  size="sm"
                  style="width: 55px;"
                  @click="serviceForm.is_recurring = true"
                >Sí</b-button>
                <b-button
                  :variant="serviceForm.is_recurring == null ? 'outline-danger' : serviceForm.is_recurring === false ? 'primary' : 'outline-secondary'"
                  size="sm"
                  style="width: 55px;"
                  @click="serviceForm.is_recurring = false"
                >No</b-button>
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group>
              <template #label>
                <span>¿Valorar garantía?</span><span class="asterisk">*</span>
              </template>
              <div class="d-flex">
                <b-button
                  class="mr-2"
                  :variant="serviceForm.warranty_evaluation_required == null ? 'outline-danger' : serviceForm.warranty_evaluation_required === true ? 'primary' : 'outline-secondary'"
                  size="sm"
                  style="width: 55px;"
                  @click="serviceForm.warranty_evaluation_required = true"
                >Sí</b-button>
                <b-button
                  :variant="serviceForm.warranty_evaluation_required == null ? 'outline-danger' : serviceForm.warranty_evaluation_required === false ? 'primary' : 'outline-secondary'"
                  size="sm"
                  style="width: 55px;"
                  @click="serviceForm.warranty_evaluation_required = false"
                >No</b-button>
              </div>
            </b-form-group>
          </b-col>
        </b-row>

        <ValidationProvider :rules="{required: true}" name="Tipo de equipo" v-slot="{valid, errors }">
          <b-form-group>
            <template #label>
              <span>Tipo de equipo</span><span class="asterisk">*</span>
            </template>
            <b-select
              v-model="serviceForm.system_type"
              :options="equipmentTypeOptions"
              :state="(errors[0] || !valid) ? false : null"
            >
              <template #first>
                <option :value="null" disabled>-- Seleccione --</option>
              </template>
            </b-select>
          </b-form-group>
        </ValidationProvider>

        <b-alert v-if="clientForm.client_id" variant="info" show class="text-center">
          <font-awesome-icon :icon="['far', 'info-circle']" fixed-width />
          Condición de pago: <b>{{ clientForm.payment_terms || 'No definido' }}</b>
        </b-alert>

        <ValidationProvider :rules="{ required: true }" name="forma de pago" v-slot="{valid, errors }">
          <b-form-group>
            <template #label>
              <span>Forma de pago</span><span class="asterisk">*</span>
            </template>
            <b-select
              v-model="serviceForm.payment_type"
              :options="paymentTypeAvailableOptions"
              :state="(errors[0] || !valid) ? false : null"
            >
              <template #first>
                <option :value="null" disabled>-- Seleccionar --</option>
              </template>
            </b-select>
          </b-form-group>
        </ValidationProvider>

        <ValidationProvider :rules="{ required: true, min: 5, max: 199 }" name="comentarios" v-slot="{ valid, errors }">
          <b-form-group>
            <template #label>
              <span>Comentarios internos</span><span class="asterisk">*</span>
            </template>
            <b-textarea
              v-model="serviceForm.comments"
              placeholder="Comentarios internos de la solicitud de servicio"
              rows="3"
              :state="(errors[0] || !valid) ? false : null"
            />
          </b-form-group>
        </ValidationProvider>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import { Spanish } from 'flatpickr/dist/l10n/es.js'
import { ValidationProvider } from 'vee-validate'
import {
  sapSeriesOptions,
  paymentTypeOptions,
  businessUnits,
  equipmentTypeOptions
} from '../../../../../sharedOptions/serviceCallModule'

export default {
  name: 'ServiceForm',
  components: { flatPickr, ValidationProvider },
  props: {
    serviceForm: { type: Object, required: true },
    clientForm: { type: Object, required: true },
  },
  data() {
    return {
      flatpickrConfig: {
        locale: { ...Spanish, firstDayOfWeek: 0 },
        altInput: true,
        altFormat: 'd/m/Y',
        // minDate: 'today',
        disableMobile: true,
      },
      sapSeriesOptions: sapSeriesOptions,
      paymentTypeOptions: paymentTypeOptions,
      businessUnits : businessUnits,
      equipmentTypeOptions: equipmentTypeOptions,
    }
  },
  computed: {
    businessUnitOptions() {
      return this.businessUnits.sort((a, b) => a.text.localeCompare(b.text, 'es'))
    },
    minDate () {
      return new Date()?.toISOString()?.split('T')[0]
    },
    dueDateRequired () {
      return this.serviceForm.sap_series == 61
    },
    paymentTypeAvailableOptions () {
      if (this.clientForm?.payment_terms === 'Contado') {
        return [
          { value: 'Sinpe',  text: 'Sinpe' },
          { value: 'Tarjeta',  text: 'Tarjeta' },
          { value: 'Efectivo',  text: 'Efectivo' },
          { value: 'Transferencia',  text: 'Transferencia' }
        ]
      }

      return this.paymentTypeOptions
    }
  },
}
</script>

<style scoped>
  .asterisk { color: #dc2626; margin-left: 2px; }
</style>
